import {  BaseAssetFragment } from '../../generated/graphql.generated';

export const EVENT_STATUS_ICON_MAP = [
    {
        status: 'pending',
        icon: 'pi-minus-circle'
    },
    {
        status: 'booked',
        icon: 'pi-calendar'
    },
    {
        status: 'cancelled',
        icon: 'pi-times-circle'
    },
    {
        status: 'confirmed',
        icon: 'pi-thumbs-up'
    },
    {
        status: 'completed',
        icon: 'pi-check-circle'
    },
];

// Requirement: 6623 — show a "W" on confirmed/completed schedule events whose job had its
// welcome call checked off on the Ops Readiness dashboard. The dashboard writes the flag to job
// metadata as the string 'true'/'false'; a boolean true is also accepted, matching the backend's
// opsReadinessFlag report column.
const WELCOME_CALL_STATUSES = ['confirmed', 'completed'];

export function showWelcomeCallIndicator(event: {
    status?: string | null;
    job?: { metadata?: Record<string, unknown> | null } | null;
}): boolean {
    if (!WELCOME_CALL_STATUSES.includes(event?.status)) {
        return false;
    }
    const welcomeOk = event.job?.metadata?.calculatorOutput__welcomeOk;
    return welcomeOk === true || welcomeOk === 'true';
}

// Controls the order for the rendering of assets on the schedule
export const RESOURCE_ORDER = ['Unassigned', 'Truck', 'Delivery', 'Overnight Storage', 'Estimator'];

export const TRAVEL_TYPES = {
    dockToStart: 'dock to start',
    endToDock: 'end to dock'
};

/**
 * Sorts an array of assets by resource order and then name.
 */
export function sortAssetsForSchedule(assets: BaseAssetFragment[]) {
    assets.sort((a, b) => {
        // If the resource order matches sort by name
        if (RESOURCE_ORDER.indexOf(a.type) === RESOURCE_ORDER.indexOf(b.type)) {
            return a.name.localeCompare(b.name, 'en', { numeric: true });
        } else {
            return RESOURCE_ORDER.indexOf(a.type) - RESOURCE_ORDER.indexOf(b.type);
        }
    });
}
